import { schema } from 'normalizr';
import { PapiDeviation } from '@wix/da-papi-types';
import { userSchema, userListSchema } from './user';
import { DeviationResourceType } from '../../../types/deviation';

const getCompositeId = (typeId: number, deviationId: number) =>
  typeId === DeviationResourceType.ART ? deviationId : `${typeId}-${deviationId}`;

const getDeviationEntityId = (value: PapiDeviation) =>
  getCompositeId(value.typeId, value.deviationId) as string;

const getDeviationEntityIds = (values: PapiDeviation[]) => values.map(getDeviationEntityId);

const processStrategy = (value: PapiDeviation) => {
  return { ...value, entityId: getDeviationEntityId(value) };
};

const deviationSchema = new schema.Entity(
  'deviation',
  {
    author: userSchema,
    groupDestination: userSchema,
  },
  {
    idAttribute: getDeviationEntityId,
    processStrategy,
  }
);
const deviationListSchema = [deviationSchema];

// #region extended deviation
const collectionListSchema = new schema.Array({
  collection: { owner: userSchema, thumb: deviationSchema },
  deviations: deviationListSchema,
});

const relatedContentSchema = new schema.Array({
  deviations: deviationListSchema,
  collections: collectionListSchema,
  groups: userListSchema,
});

const deviationExtendedSchema = new schema.Entity(
  'deviationExtended',
  {
    relatedContent: relatedContentSchema,
    exclusiveGroup: userSchema,
  },
  {
    idAttribute: (value, parent, key) =>
      getCompositeId(parent.typeId, parent.deviationId) as string,
    processStrategy: (value, parent, key) => ({
      ...value,
      parentDeviationEntityId: getCompositeId(parent.typeId, parent.deviationId),
    }),
  }
);

// add extended to the deviation schema...
deviationSchema.define({ extended: deviationExtendedSchema });
// #endregion

export {
  deviationSchema,
  deviationListSchema,
  deviationExtendedSchema,
  getDeviationEntityId,
  getDeviationEntityIds,
  getCompositeId,
};
